import { render, staticRenderFns } from "./MerchantTransaction.vue?vue&type=template&id=0edd4871"
import script from "./MerchantTransaction.vue?vue&type=script&lang=js"
export * from "./MerchantTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports